import { render, staticRenderFns } from "./ConversionMg.vue?vue&type=template&id=6bb0b112&scoped=true&lang=pug&"
var script = {}
import style0 from "./ConversionMg.vue?vue&type=style&index=0&id=6bb0b112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0b112",
  null
  
)

export default component.exports